import { formatMoney } from 'accounting'

export function formatBR (value, { noPrefix } = {}) {
  return formatMoney(value, noPrefix ? '' : 'R$ ', 2, '.', ',')
}
